import axios from "axios";
import axiosInstance from "./axiosInstance.js";

export const iniciarSesion = async (data) => {
  try 
  {
    //peticion
    const response = await axios.post(`${process.env.REACT_APP_LARAVEL_API}/login`, data);
    return response.data;
  } 
  catch (error) //ocurre un error
  {
    if (error.response)  //intenta devolver el error del endpoint 
      return error.response.data;
    else //no llega al endpoint
      return null;
  }
};

export const iniciarSesionMicrosoft = async () => {
  try 
  {
    //peticion
    const response = await axios.post(`${process.env.REACT_APP_LARAVEL_API}/microsoft`, null);
    return response.data;
  } 
  catch (error) //ocurre un error
  {
    if (error.response)  //intenta devolver el error del endpoint 
      return error.response.data;
    else //no llega al endpoint
      return null;
  }
};


export const passwordOlvidado = async (data) => {
  try 
  {
    //peticion
    const response = await axios.post(`${process.env.REACT_APP_LARAVEL_API}/forgot-password`, data);
    return response.data;
  } 
  catch (error) //ocurre un error
  {
    if (error.response)  //intenta devolver el error del endpoint 
      return error.response.data;
    else //no llega al endpoint
      return null;
  }
};


export const restaurarPassword = async (data) => {
  try 
  {
    //peticion
    const response = await axios.post(`${process.env.REACT_APP_LARAVEL_API}/restore-password`, data);
    return response.data;
  } 
  catch (error) //ocurre un error
  {
    if (error.response)  //intenta devolver el error del endpoint 
      return error.response.data;
    else //no llega al endpoint
      return null;
  }
};


export const restaurarPrimerPassword = async (data) => {
  try 
  {
    //peticion
    const response = await axios.post(`${process.env.REACT_APP_LARAVEL_API}/restore-first-password`, data);
    return response.data;
  } 
  catch (error) //ocurre un error
  {
    if (error.response)  //intenta devolver el error del endpoint 
      return error.response.data;
    else //no llega al endpoint
      return null;
  }
};


/*------------------------- G    R   U   P   O   S  -------------------------*/
export const obtenerListadoGrupos = async (data) => {
  try 
  {
    //peticion
    const response = await axios.get(`${process.env.REACT_APP_LARAVEL_API}/grupos`, data);
    return response.data;
  } 
  catch (error) //ocurre un error
  {
    console.log({error});
    
    if (error.response)  //intenta devolver el error del endpoint 
      return [];
    else //no llega al endpoint
      return [];
  }
};


export const crearGrupo = async (data) => {
  try 
  {
    //peticion
    const response = await axios.post(`${process.env.REACT_APP_LARAVEL_API}/grupos`, data);
    return response.data;
  } 
  catch (error) //ocurre un error
  {
    console.log({error});
    
    if (error.response)  //intenta devolver el error del endpoint 
      return [];
    else //no llega al endpoint
      return [];
  }
};

export const editarGrupo = async (data, id) => {
  try 
  {
    const response = await axios.post(`${process.env.REACT_APP_LARAVEL_API}/grupos/${id}`, data);
    return response.data;
  } 
  catch (error) //ocurre un error
  {
    console.log({error});
    
    if (error.response)  //intenta devolver el error del endpoint 
      return [];
    else //no llega al endpoint
      return [];
  }
};


/*------------------------- I    N   V   I   T   A    C   I   O   N   E   S  -------------------------*/
export const crearInvitacion = async (data, id) => {
  try 
  {
    const response = await axios.post(`${process.env.REACT_APP_LARAVEL_API}/invitaciones`, data);
    return response.data;
  } 
  catch (error) //ocurre un error
  {
    console.log({error});
    if (error.response)  //intenta devolver el error del endpoint 
      return false;
    else //no llega al endpoint
      return false;
  }
};


export const actualizarInvitacion = async (data) => {
  try 
  {
    const response = await axios.post(`${process.env.REACT_APP_LARAVEL_API}/invitaciones/update`, data);
    return response.data;
  } 
  catch (error) //ocurre un error
  {
    console.log({error});
    
    if (error.response)  //intenta devolver el error del endpoint 
      return [];
    else //no llega al endpoint
      return [];
  }
};

export const eliminarInvitacion = async (id) => {
  try 
  {
    //peticion
    const response = await axios.post(`${process.env.REACT_APP_LARAVEL_API}/eliminarInvitacion/${id}`, null);
    return response.data;
  } 
  catch (error) //ocurre un error
  {
    console.log({error});
    return error;
  }
};


export const obtenerListadoInvitaciones = async (data) => {
  try 
  {
    const response = await axios.get(`${process.env.REACT_APP_LARAVEL_API}/invitaciones`, data);
    return response.data;
  } 
  catch (error) //ocurre un error
  {
    console.log({error});
    if (error.response)  //intenta devolver el error del endpoint 
      return [];
    else //no llega al endpoint
      return [];
  }
};


/*------------------------- U    S   U   A   R   I    O     S  -------------------------*/
export const obtenerListadoUsuarios = async (data) => {
  try 
  {
    //peticion
    const response = await axios.get(`${process.env.REACT_APP_LARAVEL_API}/usuarios`, data);
    return response.data;
  } 
  catch (error) //ocurre un error
  {
    console.log({error});
    
    if (error.response)  //intenta devolver el error del endpoint 
      return [];
    else //no llega al endpoint
      return [];
  }
};


export const crearUsuarios = async (data) => {
  try 
  {
    //peticion
    const response = await axios.post(`${process.env.REACT_APP_LARAVEL_API}/usuarios/crearUsuario`, data);
    return response.data;
  } 
  catch (error) //ocurre un error
  {
    console.log({error});
    
    if (error.response)  //intenta devolver el error del endpoint 
      return [];
    else //no llega al endpoint
      return [];
  }
};


export const editarUsuarios = async (data,id) => {
  try 
  {
    //peticion
    const response = await axios.post(`${process.env.REACT_APP_LARAVEL_API}/usuarios/update/${id}`, data);
    return response.data;
  } 
  catch (error) //ocurre un error
  {
    console.log({error});
    
    if (error.response)  //intenta devolver el error del endpoint 
      return [];
    else //no llega al endpoint
      return [];
  }
};


/*------------------------- M    I   E   M   B   R    O     S  -------------------------*/
export const obtenerListadoMiembros = async (id) => {
  try 
  {
    //peticion
    const response = await axios.get(`${process.env.REACT_APP_LARAVEL_API}/usuariosGrupos/miembros/${id}`, null);
    return response.data;
  } 
  catch (error) //ocurre un error
  {
    console.log({error});
    
    if (error.response)  //intenta devolver el error del endpoint 
      return [];
    else //no llega al endpoint
      return [];
  }
};


export const obtenerGruposXUsuario = async (id) => {
  try 
  {
    //peticion
    const response = await axios.get(`${process.env.REACT_APP_LARAVEL_API}/usuariosGrupos/misGrupos/${id}`, null);
    return response.data;
  } 
  catch (error) //ocurre un error
  {
    console.log({error});
    
    if (error.response)  //intenta devolver el error del endpoint 
      return [];
    else //no llega al endpoint
      return [];
  }
};


export const actualizarGruposxUsuario = async (data) => {
  try 
  {
    //peticion
    const response = await axios.post(`${process.env.REACT_APP_LARAVEL_API}/usuariosGrupos/actualizarGrupos`, data);
    return response.data;
  } 
  catch (error) //ocurre un error
  {
    console.log({error});
    
    if (error.response)  //intenta devolver el error del endpoint 
      return [];
    else //no llega al endpoint
      return [];
  }
};


/*------------------------- L    I   C   E   N   C    I     A       S  -------------------------*/
export const obtenerListadoLicencias = async () => {
  try 
  {
    //peticion
    const response = await axios.get(`${process.env.REACT_APP_LARAVEL_API}/licencias`, null);
    return response.data;
  } 
  catch (error) //ocurre un error
  {
    console.log({error});
    
    if (error.response)  //intenta devolver el error del endpoint 
      return [];
    else //no llega al endpoint
      return [];
  }
};

export const crearLicencias = async (data) => {
  try 
  {
    //peticion
    const response = await axios.post(`${process.env.REACT_APP_LARAVEL_API}/licencias`, data);
    return response.data;
  } 
  catch (error) //ocurre un error
  {
    console.log({error});
    
    if (error.response)  //intenta devolver el error del endpoint 
      return [];
    else //no llega al endpoint
      return [];
  }
};

export const editarLicencias = async (data, id) => {
  try 
  {
    //peticion
    const response = await axios.post(`${process.env.REACT_APP_LARAVEL_API}/licencias/${id}`, data);
    return response.data;
  } 
  catch (error) //ocurre un error
  {
    console.log({error});
    
    if (error.response)  //intenta devolver el error del endpoint 
      return [];
    else //no llega al endpoint
      return [];
  }
};

export const asignarLicencia = async (data) => {
  try 
  {
    //peticion
    const response = await axios.post(`${process.env.REACT_APP_LARAVEL_API}/asignarLicencia`, data);
    return response.data;
  } 
  catch (error) //ocurre un error
  {
    console.log({error});
    
    if (error.response)  //intenta devolver el error del endpoint 
      return [];
    else //no llega al endpoint
      return [];
  }
};

export const verLicenciaEspecifica = async (id) => {
  try 
  {
    //peticion
    const response = await axios.get(`${process.env.REACT_APP_LARAVEL_API}/verLicenciasEnUso/${id}`, null);
    return response.data;
  } 
  catch (error) //ocurre un error
  {
    console.log({error});
    
    if (error.response)  //intenta devolver el error del endpoint 
      return [];
    else //no llega al endpoint
      return [];
  }
};

export const verMisLicencias = async (id) => {
  try 
  {
    //peticion
    const response = await axios.get(`${process.env.REACT_APP_LARAVEL_API}/misLicencias/${id}`, null);
    return response.data;
  } 
  catch (error) //ocurre un error
  {
    console.log({error});
    
    if (error.response)  //intenta devolver el error del endpoint 
      return [];
    else //no llega al endpoint
      return [];
  }
};


/* --------------------------- enpoints con token --------------------------- */
export const obtenerSesion = async () => {
  try 
  {
    //peticion
    const response = await axiosInstance.post("/getUsuario");
    return response.data;
  } 
  catch (error) //ocurre un error
  {
    if (error.response)  //intenta devolver el error del endpoint 
      return error.response.data;
    else //no llega al endpoint
      return null;
  }
};


export const cerrarSesion = async () => {
  try 
  {
    //peticion
    const response = await axiosInstance.post("/logout");
    localStorage.removeItem('sesionIniciada');
    return response.data;
  } 
  catch (error) //ocurre un error
  {
    if (error.response)  //intenta devolver el error del endpoint 
      return error.response.data;
    else //no llega al endpoint
      return null;
  }
};
